import React from 'react';
import { Box } from '@mantine/core';

import RequestMatchesActions from './actions/RequestMatchesActions';
import NewRequestActions from './actions/NewRequestActions';
import ValidatedRequestActions from './actions/ValidatedRequestActions';
import SearchActions from './actions/SearchActions';
import MatchActions from './actions/MatchActions/MatchActions';

interface EvidenceActionsProps {
  isIdeaPage: boolean;
  isIdeaAi: boolean;
  finalIsGenerated: boolean;
  isGapMatch: boolean;
  isRequestMatch: boolean;
  isRequestInreview: boolean;
  isAssigned: boolean;
  status: string;
  navToPerspective: any;
  componentId: string;
  finalChosenEvidence: any;
  componentType: string;
  propGetUnreadNotificationsCountByRequest?: (requestId: string) => number;
  setActiveSearch?: (active: boolean) => void;
}

const EvidenceActions: React.FC<EvidenceActionsProps> = ({
  isIdeaPage,
  isIdeaAi,
  finalIsGenerated,
  isGapMatch,
  isRequestMatch,
  isRequestInreview,
  isAssigned,
  status,
  navToPerspective,
  componentId,
  finalChosenEvidence,
  componentType,
  propGetUnreadNotificationsCountByRequest,
  setActiveSearch
}) => {
  if (!(isIdeaPage || isIdeaAi) || finalIsGenerated) {
    return null;
  }

  return (
    <Box>
      {isGapMatch && status !== "search" && (
        <MatchActions 
          navToPerspective={navToPerspective}
          componentId={componentId}
          chosenEvidence={finalChosenEvidence}
          setValidationCount={(count: number) => count}
          setIsValidationDone={(done: boolean) => done}
          componentType={componentType}
          getUnreadNotificationsCountByRequest={isIdeaAi ? propGetUnreadNotificationsCountByRequest : undefined}
        />
      )}
      
      {isRequestMatch && status !== "search" && (
        <RequestMatchesActions 
          navToPerspective={navToPerspective}
          componentId={componentId}
          chosenEvidence={finalChosenEvidence}
        />
      )}

      {isRequestInreview && status !== "search" && (
        <NewRequestActions
          navToPerspective={navToPerspective}
          componentId={componentId}
          chosenEvidence={finalChosenEvidence}
        />
      )}
      
      {(isAssigned && status !== "search") && (
        <ValidatedRequestActions
          navToPerspective={navToPerspective}
          chosenEvidence={finalChosenEvidence}
        />
      )}

      {status === "search" && ( 
        <SearchActions
          navToPerspective={navToPerspective}
          setActiveSearch={setActiveSearch}
          chosenEvidence={finalChosenEvidence}
          componentId={componentId}
        />
      )}
    </Box>
  );
};

export default EvidenceActions; 